module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-180x180-bc7a8d873429e9f7ff34130c3dac6b37.png";